<script setup lang="ts">
import 'jquery-validation';

import $ from 'jquery';
import {
    onMounted,
    shallowRef,
    unref,
    watch,
} from 'vue';

import { useGenerateIds } from '#public_ts/composables';

import updateDataAttributes from './data-attributes';

const props = defineProps<{
    id?: string;
    name?: string;
    modelValue?: File[];
    data?: Record<string, unknown>;
    plain?: boolean;
    trigger?: number;
    reset?: number;
}>();
//eslint-obsolete no-spaced-func
const emit = defineEmits<{
    (event: 'update:modelValue', value: File[]): void;
    (event: 'control', value: HTMLInputElement): void;
    (event: 'cancel'): void;
}>();

const input = shallowRef<HTMLInputElement | undefined>();
const generateIds = useGenerateIds();
const controlId = props.id || generateIds();
const controlName = (props.name === '--') ? undefined : (props.name || controlId);

watch(() => props.data, (val) => {
    const _input = unref(input);
    if(_input && val) {
        updateDataAttributes($(_input), val);
    }
}, { deep: true });

function _reset() {
    const _input = unref(input);
    if(_input) {
        //reset file control
        try {
            _input.value = '';
        } catch{ /**/ }
        try {
            _input.type = '';
        } catch{ /**/ }
        try {
            _input.type = 'file';
        } catch{ /**/ }
    }
}
watch(() => props.modelValue, (val) => {
    if(!val || !val.length) _reset();
});
watch(() => props.reset, () => {
    _reset();
});

watch(() => props.trigger, () => {
    _reset();
    const _input = unref(input);
    if(_input) {
        _input.click();
    }
});

onMounted(() => {
    const _input = unref(input);
    if(_input) {
        if(props.data) {
            updateDataAttributes($(_input), props.data);
        }
    }
});

function onChange(e: Event) {
    const control = (e.target as HTMLInputElement | null) || unref(input);
    const files = control?.files;
    const array: File[] = [];
    if(files) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < files.length; i++) {
            const file = files[i];
            if(file) array.push(file);
        }
    }
    emit('update:modelValue', array);
    if(control) emit('control', control);
}
</script>
<template>
    <input
        :id="controlId"
        ref="input"
        :name="controlName"
        type="file"
        :class="props.plain ? '' : 'form-control'"
        @change="onChange"
        @cancel="emit('cancel')"
    >
</template>
